import { ref, reactive } from "vue";

let instance = null;

export function useBadgeHolders() {
  if (instance) return instance;

  const allBadgeHolders = ref([]);
  const badgeHoldersCount = ref(0);

  const paginationDefaultParams = reactive({
    limit: 10,
    offset: 0,
  });

  const filterParams = reactive({
    status: [],
    level: [],
  });

  const orderingData = reactive({
    field: "issued_to__first_name",
  });

  const getBadgeHoldersCount = () => {
    return badgeHoldersCount.value;
  };

  const setPaginationDataOffset = (offset) => {
    paginationDefaultParams.offset = offset;
  };

  const setPaginationDataLimit = (limit) => {
    paginationDefaultParams.limit = limit;
  };

  const setOrderingDataField = (field) => {
    orderingData.field = field;
  };

  const setStatusFilter = (statuses) => {
    filterParams.status = statuses;
  };

  const setLevelFilter = (levels) => {
    filterParams.level = levels;
  };

  instance = {
    allBadgeHolders,
    badgeHoldersCount,
    paginationDefaultParams,
    orderingData,
    filterParams,
    getBadgeHoldersCount,
    setPaginationDataOffset,
    setPaginationDataLimit,
    setOrderingDataField,
    setStatusFilter,
    setLevelFilter,
  };

  return instance;
}

export function resetBadgeHolders() {
  instance = null;
}

